export enum AnalyticsEventName {
  LanguageChange = 'language-change',
  SearchOnCategory = 'search-on-category',
  SeeDocumentDetails = 'see-document-details',
  ToOCIWebsite = 'to-oci-website',
  SearchOnFreeText = 'search-on-free-text',
  SeeDocument = 'see-document',
  DownloadDocument = "download-document"
}

export enum AnalyticsEventCategory {
  Interface = 'interface',
  Search = 'search',
}

export type AnalyticsEvent = { name: AnalyticsEventName; category: AnalyticsEventCategory; label?: string };
